import { CUSTOM_ELEMENTS_SCHEMA, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '../../services/commonservice';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColDef } from 'ag-grid-community';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid/isg-grid.component';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import OktaAuth, { extend } from '@okta/okta-auth-js';
import { BaseHttpReqRespService } from '../../../../modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-page-constant-sum',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IsgGridComponent],
  templateUrl: './page-constant-sum.component.html',
  styleUrl: './page-constant-sum.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [CommonService]
})

export class PageConstantSumComponent extends BaseHttpReqRespService {
  private gridApi!: any;
  public rowIndex: string = "";
  public tmpMappingId: number = 0;
  public oktaTokenDetails!: oktaToken;
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  public questionDescription: string = "";
  myAppUrl: any;
  public questionId!: number;
  public folderId!: number;
  public folderName!: string;
  constantsumForm!: FormGroup;
  subCategoryForm!: FormGroup;
  createCategoryForm!: FormGroup;
  public categoryName!: string;
  public categoryDescription!: string;
  public categoryId!: number;
  public categoryValue!: number;
  public categoryDetails!: categoryDetail;
  public categoryList: categoryDetail[] = [];
  public subCategoryDetails!: subCategoryDetail;
  public subCategoryList: subCategoryDetail[] = [];
  public categorySubCategoryList: subCategoryDetail[] = [];
  public subCategoryName!: string;
  public subCategoryId!: number;
  public type: string = "ConstantSum";
  public questionCategoryId: number = 0;
  public questionCategoryList: questionCategory[] = [];
  quesCategoryForm!: FormGroup;
  public width!: number;
  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;
  successOrFailureMessage: string = '';

  public showTitlePanel: boolean = true;
  public showSchemaPanel: boolean = false;

  subCategoryGridConfig: Partial<IsgGridConfig> = {
    height: '350px',
    pagination: false,
    rowSelection: 'multiple',
  };
  @ViewChild('CreateUpdateCategoryModal') createUpdateCategoryModal!: TemplateRef<any>;
  @ViewChild('CreateCategoryModal') categoryModal!: TemplateRef<any>;
  @ViewChild('DeleteConfirmation') deleteConfirmationModal!: TemplateRef<any>;

  constructor
    (@Inject(OKTA_AUTH) private oauth: OktaAuth,
      @Inject('BASE_URL') baseUrl: string,
      @Inject('CONFIG_SETTINGS') configSettings: any,
      private _router: Router,
      public http: HttpClient,
      private formBuilder: FormBuilder,
      private commonService: CommonService,
      private modalService: NgbModal,
      private renderer: Renderer2,
      private route: ActivatedRoute,
      private EncrDecr: EncrDecrService
    ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.myAppUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl += '/';
  }
  backUrl() {
    if (this.folderId == -1)
      this._router.navigate(['/question']);
    else
      this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
  }


  ngOnInit() {
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
    this.questionId = +this.route.snapshot.queryParams["questionId"];
    this.folderId = this.route.snapshot.queryParams["folderId"];
    this.folderName = this.route.snapshot.queryParams["folderName"];

    this.constantsumForm = this.formBuilder.group({
      'description': new FormControl(null, Validators.required),
      'categoryName': new FormControl(null, null),
      'categoryValue': new FormControl(null, null),
      'categoryId': new FormControl(null, null),
      'createdBy': new FormControl(null, null),
      'questionId': new FormControl(null, null),
      'folderId': new FormControl(null, null),
      'type': new FormControl(null, null),
      'categoryList': new FormControl(null, null),
      'questionCategoryId': new FormControl(null, null),
      'width': new FormControl(''),
      'shortName': new FormControl('')
    });

    this.createCategoryForm = this.formBuilder.group({
      'categoryDescription': new FormControl(null, [Validators.required, this.noWhitespaceValidator]),
      'categoryName': new FormControl(null, [Validators.required, this.noWhitespaceValidator]),
      'categoryValue': new FormControl(null, Validators.required),
      'categoryId': new FormControl(null, null),
      //'categorySubCategoryList': new FormControl(null,null)
    });

    this.subCategoryForm = this.formBuilder.group({
      'subCategoryName': new FormControl(null, [Validators.required, this.noWhitespaceValidator]),
      'subCategoryId': new FormControl(null, null),
      'categoryId': new FormControl(null, null),
      'isResponsePresent': new FormControl(false)
    })

    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestion();
    this.getQuestionCategoryList();
  }

  public noWhitespaceValidator(control: import('@angular/forms').AbstractControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm?.get('quesCategoryName')?.value;
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(resourceIdList, this.myAppUrl + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }

  PatchCategoryModal(categoryId: any) {
    if (categoryId > 0) {
      let tmpArray = this.categoryList.filter(x => x.categoryId === categoryId);
      this.createCategoryForm.patchValue({
        categoryName: tmpArray[0].categoryName,
        categoryDescription: tmpArray[0].categoryDescription,
        categoryValue: tmpArray[0].categoryValue,
        categoryId: tmpArray[0].categoryId,
        //categorySubCategoryList: tmpArray[0].categorySubCategoryList,
      });
      this.categorySubCategoryList = tmpArray[0].categorySubCategoryList;
      this.subCategoryList = tmpArray[0].categorySubCategoryList;
      this.categoryId = categoryId;
    }
  }

  DeleteCategory(categoryId: any) {
    if (categoryId > 0) {
      var elementPos = this.categoryList.map(function (x) { return x.categoryId; }).indexOf(categoryId);
      if (elementPos > -1) {
        this.categoryList.splice(elementPos, 1);
      }
    }
  }



  AddUpdateCategory(categoryId: any) {
    this.categoryId = categoryId;
    let rowCount = this.categoryList.length; //this.gridApi.getDisplayedRowCount();
    this.categoryName = this.createCategoryForm?.get('categoryName')?.value;
    this.categoryValue = this.createCategoryForm?.get('categoryValue')?.value;
    this.categoryDescription = this.createCategoryForm?.get('categoryDescription')?.value;

    if (this.categoryId > 0) {

      this.categoryDetails = {
        categoryName: this.categoryName,
        categoryValue: this.categoryValue,
        categoryDescription: this.categoryDescription,
        categoryId: this.categoryId,
        categorySubCategoryList: this.categorySubCategoryList
      };

      var elePos = this.categoryList.map(function (x) { return x.categoryId; }).indexOf(categoryId);
      if (elePos > -1) {
        this.categoryList[elePos] = this.categoryDetails;
      }

    }
    else {

      this.categoryDetails = {
        categoryName: this.categoryName,
        categoryValue: this.categoryValue,
        categoryDescription: this.categoryDescription,
        categoryId: ++rowCount,
        categorySubCategoryList: this.categorySubCategoryList

      };
      this.categoryList.push(this.categoryDetails);
    }
    this.categoryId = this.categoryId;
    this.PatchCategoryModal(this.categoryId);
  }

  AddUpdateSubCategory(categoryId: any) {
    this.subCategoryName = this.subCategoryForm?.get('subCategoryName')?.value;
    this.subCategoryId = this.subCategoryForm?.get('subCategoryId')?.value;
    let isResponsePresent = this.subCategoryForm?.get('isResponsePresent')?.value;
    this.PatchCategoryModal(categoryId);
    let rowCount = this.subCategoryList.length; //this.gridApi.getDisplayedRowCount();

    if (isResponsePresent == null) {
      isResponsePresent = false;
    }
    if (this.subCategoryId > 0) {
      this.subCategoryDetails = {
        subCategoryName: this.subCategoryName,
        subCategoryId: this.subCategoryId,
        categoryId: categoryId,
        isResponsePresent: isResponsePresent
      };
      let objIndex = this.subCategoryList.findIndex((obj => obj.subCategoryId == this.subCategoryDetails.subCategoryId));
      this.subCategoryList[objIndex].subCategoryName = this.subCategoryDetails.subCategoryName;

      var selected = this.gridApi.getFocusedCell();
      this.rowIndex = selected.rowIndex;
      const index = Number(this.rowIndex);//this.subCategoryList.indexOf(key, 0);

      let currentRow = this.gridApi.getRowNode(index);
      var updateItem = this.subCategoryDetails;

      if (this.gridApi.updateRowData) {
        this.gridApi.updateRowData({ remove: [currentRow.data] });

        this.gridApi.updateRowData({
          add: [updateItem],
          addIndex: index
        });

      }



    }
    else {
      this.subCategoryDetails = {
        subCategoryName: this.subCategoryName,
        subCategoryId: ++rowCount,
        categoryId: categoryId,
        isResponsePresent: isResponsePresent
      };
      var newItem = this.subCategoryDetails;
      if (this.gridApi.updateRowData) {
        this.gridApi.updateRowData({ add: [newItem] });
      }
      this.subCategoryList.push(this.subCategoryDetails);
    }
    this.PatchCategoryModal(categoryId);
    if (this.gridApi && this.categoryList) {
      const cat = this.categoryList.find(x => x.categoryId === categoryId);
      if (cat) {
        this.gridApi.setRowData(cat.categorySubCategoryList);
      }
    }
    this.subCategoryForm.reset();
  }
  saveConstantSumQuestion() {
    let tmpWidth = this.constantsumForm.controls.width.value;
    let tmpShortName = this.constantsumForm.controls.shortName.value;
    if (tmpWidth == null || tmpWidth == "") {
      tmpWidth = 0;
    }
    const objQuestion = {
      ...this.constantsumForm.value,
      categoryList: this.categoryList,
      createdBy: this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      modifiedBy: this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      questionId: this.questionId,
      folderId: this.folderId,
      questionType: this.type,
      description: '',
      type: this.type,
      width: tmpWidth,
      shortName: tmpShortName
    };
    let data = JSON.stringify(objQuestion);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    this.commonService.httpPostWOHeader(
      this.myAppUrl + this.QUESTION_ENDPOINT.SAVE, data, httpOptions
    ).subscribe(
      questionId => {
        this.showMessage("Question Saved Successfully.");
        setTimeout(() => {
          this.showMessage('');
          this.folderId = + this.route.snapshot.queryParams["folderId"];
          this.folderName = this.route.snapshot.queryParams["folderName"]; this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
          this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
          var location = window.location.pathname;
          if (location.includes("/client") == false) {

            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }
          else {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }
        }, 2000);
      },
      err => {
        console.log("Error- something is wrong!" + err.status + err.message)
      });

  }


  colDefsSubCategory: ColDef[] = [
    { headerName: 'isResponsePresent', field: 'isResponsePresent', hide: true, width: 0 },
    { headerName: 'SubCategoryId', field: 'subCategoryId', hide: true },
    { headerName: 'Sub-Category', field: 'subCategoryName', width: 700, resizable: true, filter: true },
    { headerName: 'Edit', field: '', cellRenderer: this.editLinkRenderer.bind(this), width: 250, resizable: true },
    { headerName: 'Delete', field: '', cellRenderer: this.deleteLinkRenderer.bind(this), width: 250, resizable: true }
  ];

  deleteLinkRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    if (params.data.isResponsePresent == true) {
      elementI.setAttribute('class', 'fa fa-trash anchor-cursor disabled');
    }
    else {
      elementI.setAttribute('class', 'fa fa-trash anchor-cursor');
      this.renderer.setStyle(element, 'cursor', 'pointer');
      this.renderer.listen(element, 'click', () => {
        this.rowIndex = params.node.rowIndex;
        this.categoryId = params.data.categoryId;
        this.openDeleteConfirmationModal();
      });
    }
    this.renderer.appendChild(element, elementI);
    this.rowIndex = params.node.rowIndex;
    this.categoryId = params.data.categoryId;
    return element;
  }

  DeleteSubCategory() {
    this.PatchCategoryModal(this.categoryId);
    var selected = this.gridApi.getFocusedCell();
    this.rowIndex = selected.rowIndex;
    const index = Number(this.rowIndex);//this.subCategoryList.indexOf(key, 0);
    if (index > -1) {
      this.subCategoryList.splice(index, 1);
      this.categorySubCategoryList = this.subCategoryList;
      this.categoryList[0].categorySubCategoryList = this.categorySubCategoryList;
      if (this.gridApi) {
        this.gridApi.setRowData(this.categoryList[0].categorySubCategoryList);
      }
    }
    let currentRow = this.gridApi.getRowNode(index);
    this.gridApi.updateRowData({ remove: [currentRow.data] });
  }

  editLinkRenderer(params: any) {
    const element = this.renderer.createElement('a');
    this.renderer.addClass(element, "fa");
    this.renderer.addClass(element, "fa-edit");
    this.renderer.setAttribute(element, 'id', params.data.mappingId);
    this.renderer.listen(element, 'click', () => {
      let parameter = "?subCategoryId=" + params.data.subCategoryId;

      this.subCategoryForm.patchValue({
        subCategoryName: params.data.subCategoryName,
        subCategoryId: params.data.subCategoryId,
        isResponsePresent: params.data.isResponsePresent
      });

    });
    return element;
  }

  onSubCategoryGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

  onRowSelected(params: any) {

  }

  showMessage(params: any) {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "block";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = params;
    }
  }

  BackUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      let fId = this.folderId;
      let fName = this.folderName;
      if (fId > 0)
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: fId, question: fName } });
      else
        this._router.navigate(['question']);
    }
    else {
      this._router.navigate(['/programoverview']);
    }
  }

  messageTimeout() {
    window.setTimeout(() => {
      this.hideMessage();
    }, 1800);
  }
  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "none";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = '';
    }
  }

  getQuestion() {
    if (this.questionId > 0) {
      let headers = new HttpHeaders({
        Authorization: 'Bearer ' + this.oktaTokenDetails.accessToken,
        'Content-Type': 'application/json'
      });

      let options = {
        headers: headers,
        params: {
          questionId: this.questionId.toString()
        }
      }

      var model = "?questionId=" + this.questionId;
      this.http.post<any>(this.oktaTokenDetails.apiHostName + '/' + this.QUESTION_ENDPOINT.GET_QUESTION, null, options)
        .subscribe(
          result => {

            this.categoryList = result.categoryList;
            this.constantsumForm.patchValue({
              description: result.description,
              categoryName: result.categoryName,
              categoryValue: result.categoryValue,
              categoryList: result.categoryList,
              questionId: result.questionId,
              createdBy: result.createdBy,
              questionCategoryId: result.questionCategoryId,
              width: result.width,
              shortName: result.shortName
            });
          },
          err => {
            console.log("Error- something is wrong!" + err.status + err.message)
          });
    }

  }

  ResetValue() {
    this.constantsumForm.reset();
  }
  openCreateUpdateCategoryModal() {
    if (this.createUpdateCategoryModal) {
      this.categoryId = 0;
      this.modalService.open(this.createUpdateCategoryModal);
    }
  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }
  openDeleteConfirmationModal() {
    if (this.deleteConfirmationModal) {
      this.modalService.open(this.deleteConfirmationModal);
    }
  }
  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(result => {
      window.setTimeout(() => {
        this.successOrFailureMessage = '';
      }, 1200);
    }, error => console.error(error));

  }
  BackToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }

  getSubCategoryGridConfig(): Partial<IsgGridConfig> {
    return { ...this.subCategoryGridConfig, height: '100px' };
  }
}

interface categoryDetail {
  categoryName: string;
  categoryValue: number;
  categoryDescription: string;
  categoryId: number;
  categorySubCategoryList: subCategoryDetail[];
}

interface subCategoryDetail {
  subCategoryName: string;
  subCategoryId: number;
  categoryId: number;
  isResponsePresent: boolean;
}

interface oktaToken {
  accessToken: string;
  apiHostName: string;
}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}


